import styled from 'styled-components';

import { WatermarkedTableContainer } from 'components/WatermarkedTableContainer';
import { TABLE_WATERMARK_POSITIONS } from 'constants/tableWatermark';
import { mediaQueryMobileLargeMin, colorGrey400 } from 'styles';

export const TableWrapper = styled(WatermarkedTableContainer).attrs(() => ({
  watermarkLeft: TABLE_WATERMARK_POSITIONS.converter.left,
  watermarkLeftMobile: TABLE_WATERMARK_POSITIONS.converter.leftMobile,
}))`
  width: 100%;
`;

export const Inner = styled.table`
  font-size: 14px;
  line-height: 18px;
  width: 100%;
`;

export const Header = styled.thead`
  & tr {
    background: #fff;
    box-shadow: inset 0px -1px 0px #e5e5e5;
  }
`;

export const Head = styled.th`
  color: ${colorGrey400};
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;

  padding: 8px 0;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 13px;
    line-height: 24px;
  }

  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0px;
    text-align: right;
  }
`;

export const Body = styled.tbody`
  color: #2d2d2d;
`;

export const Row = styled.tr`
  height: 48px;
  text-align: -webkit-left;

  &:nth-child(even) {
    background: rgba(246, 245, 248, 0.52);
  }

  & td:first-child,
  & th:first-child {
    padding-left: 8px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    & td:first-child,
    & th:first-child {
      padding-left: 16px;
    }
  }
`;

export const Ceil = styled.td`
  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
    text-align: right;
  }
`;
